import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import Button from "../../../../components/ui/Button";
import Text from "../../../../components/ui/Text";

export const CancelGameConfirmationDialog = ({ isOpen, onClose, onSubmit }) => {
  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      slotProps={{
        paper: { sx: { borderRadius: "12px", m: 2, width: "310px" } },
      }}
    >
      <DialogTitle sx={{ p: 3, pb: 1 }}>
        <Text variant="pageHeader" sx={{ mb: 0, fontSize: "20px" }}>
          Are you sure you want to cancel this game?
        </Text>
      </DialogTitle>

      <DialogContent sx={{ px: 3, py: 2 }}>
        <Text variant="paragraph" sx={{ fontSize: "16px" }}>
          Any players that have joined will be refunded the full fee in credits.
        </Text>
      </DialogContent>

      <DialogActions
        sx={{
          p: 3,
          pt: 1,
          gap: 2,
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Button
          variant="primary"
          onClick={onSubmit}
          sx={{
            flex: 1,
            fontSize: "16px",
          }}
        >
          Yes, cancel this game
        </Button>
        <Button
          variant="secondary"
          onClick={onClose}
          sx={{ flex: 1, fontSize: "16px" }}
        >
          No, don't cancel this game
        </Button>
      </DialogActions>
    </Dialog>
  );
};
